import { Grid } from "@material-ui/core";
import React from "react";
import bgImage from "../../constants/images/LOGO CARDIO-PROTECCIÓN BEXEN CARDIO-negativo-cas.png";

const LogoComponent = () => {
  return (
    <Grid
      container
      alignItems="center"
      justify="center"
      lg={6}
      md={6}
      xs={12}
      style={{
        borderTopLeftRadius: 16,
        borderBottomLeftRadius: 16,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundImage:
          "url('https://www.bexencardio.com/wp-content/uploads/2021/04/fondo.png')",
        //backgroundImage: `linear-gradient(180deg,rgba(167, 15, 177,1),rgba(11, 96, 178,1))`,
      }}
    >
      <Grid
        item
        container
        justify="center"
        alignItems="center"
        style={{ paddingTop: 24, paddingBottom: 16 }}
      >
        {<img style={{ width: "100%" }} src={bgImage} />}
      </Grid>
    </Grid>
  );
};

export default LogoComponent;
